import React from "react";
import { Box, Card, CardHeader, Avatar, CardActions, Button } from "@mui/material";
import { FaStethoscope } from "react-icons/fa";
import { BsClockFill, BsFillCalendarEventFill } from "react-icons/bs";

export default function PcpListItem(props) {
  return (
    <Box mb={1.5}>
      <Card p={2} key={props.pcp.id}>
        <CardHeader
          sx={{ color: "#0a3a56" }}
          avatar={
            <Avatar sx={{ color: "#0a3a56", bgcolor: "#f4f4f4" }}>
              <FaStethoscope />
            </Avatar>
          }
          title={props.pcp.name}
        />
        {props.pcp.notes && (
          <>
            <i style={{ 'fontSize': '15px', 'display': 'block', 'padding': '0px 25px 10px 25px' }}>
              {props.pcp.notes}
            </i>
          </>
        )}
        {
          props.pcp.days_hours_available && (
            <>
              <i style={{ 'color': '#1a237e', 'fontSize': '15px', 'display': 'block', 'padding': '0px 25px 10px 25px' }}>
                <BsClockFill style={{ 'margin-right': '6px' }}/> {props.pcp.days_hours_available}
              </i>
            </>
          )
        }
        <CardActions>
          <Button
            onClick={(e) => {
              props.selectPcp(props.pcp);
            }}
          >
            {"Select PCP"}
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
}
